import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import axios from "axios";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useGlobalContext } from "../../../../../../context";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {useLocation,useNavigate} from "react-router-dom"
const urlParams = new URLSearchParams(window.location.search);
const incomeTaxReportId = urlParams.get("id");
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



function IncomeEstimateClassForm() {
  const [incomeEstimateClass, setIncomeEstimateClass] = useState({
    needsCommittee: 0,
    committeeStatusId: "",
    committeeResult: "",
    varietiesWithCarrierId: "",
    varietiesWithCarrier: null,
    notes:''
  });
  let location =useLocation();
let navigation=useNavigate()
  const [classAmount, setClassAmount] = useState(0);
  const [messageErrors, setMessageErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  const [snackBar2, setsnackBar2] = useState({
    open: false,
    vertical: "center",
    horizontal: "center",
    message: [],
    severity: "warning",
  });

  const {
    // loading,
    committeeStatusesList,
    activitiesByIncomeTaxReportId,
    fetchData,
  } = useGlobalContext();

  useEffect(() => {
    fetchData("COMMITTEE_STATUSES_LIST", "committee_statuses_list", {});
    fetchData(
      "ACTIVITIES_BY_INCOME_TAX_REPORT_ID",
      "activities_by_income_tax_report_id",
      { income_tax_report_id: incomeTaxReportId }
    );
  }, []);

  useEffect(()=>{
    if(activitiesByIncomeTaxReportId.length==1){
      activitiesByIncomeTaxReportId.map((data)=>{
          setIncomeEstimateClass({
            ...incomeEstimateClass,
            varietiesWithCarrierId:data.id,
            varietiesWithCarrier: data,
          })
          setClassAmount(data.amount)
      })
    }
  },[activitiesByIncomeTaxReportId])


  console.log("incomeEstimateClass", incomeEstimateClass);
  //============format date to format yyyy-mm-dd============

  const submit = async () => {
    // console.log("otherBusinessFormList",otherBusinessFormList);
    // return
    setMessageErrors([]);
    setLoading(true);
    let dataForm = new FormData();

    dataForm.append(`needs_committee`, incomeEstimateClass.needsCommittee);
    dataForm.append(
      `committee_status_id`,
      incomeEstimateClass.committeeStatusId
    );
    dataForm.append(`committee_result`, incomeEstimateClass.committeeResult);
    dataForm.append(
      `varieties_with_carrier_id`,
      incomeEstimateClass.varietiesWithCarrierId
    );
    dataForm.append(`incom_tax_reports_id`, incomeTaxReportId);
    dataForm.append(`notes`, incomeEstimateClass.notes);


    let data = null;
    try {
      data = await axios({
        method: "post",
        url: ApiSetting.apiUrl + "/income_estimate_class",
        data: dataForm,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });

      // console.log("data", data);
      if (data) {
        if (data.data.status == 200) {
          resetFormState()
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "success",
            message: data.data.message,
          });
        } else if (data.data.status == 402) {
          if (data.data.data) {
            setsnackBar2({
              ...snackBar2,
              open: true,
              severity: "warning",
              message: data.data.data,
            });
          } else {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message: data.data.message,
            });
          }
        } else {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
      }
      setLoading(false);
    } catch (err) {
      console.log("data", data);
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
      setLoading(false);
    }
  };
  const resetFormState=()=>{
    setIncomeEstimateClass({
      ...incomeEstimateClass,
      needsCommittee:0,
      committeeStatusId: "",
      committeeResult: "",
      varietiesWithCarrierId: "",
      varietiesWithCarrier: null,
    })
    setClassAmount(0)
    
    // navigation(location.pathname)
  }

  return (
    <>
      {/*###==>other_business list ...  */}
      <h4
        style={{
          marginRight: "10px",
          color: "#5f7b8a",
        }}
      >
        معلومات اللجنة
      </h4>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",
          width: "98%",
          minWidth: 200,
          border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            minWidth: 200,
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth className="d-flex flex-row">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    value={
                      incomeEstimateClass.needsCommittee == 1 ? true : false
                    }
                    onChange={(e) => {
                      setIncomeEstimateClass({
                        ...incomeEstimateClass,
                        needsCommittee: e.target.checked ? 1 : 0,
                      });
                    }}
                  />
                }
                label="هل تريد تعيين لجنة للتخمين؟"
              />
            </FormGroup>
          </FormControl>

          <Typography className="fontForError"></Typography>
        </div>

        <div
          style={{
            display: incomeEstimateClass.needsCommittee ? "flex" : "none",
            flexDirection: "row",
            flexFlow: "row wrap",
            width: "100%",
            minWidth: 200,
            // border: "1px solid",
            borderColor: "#5f7b8a",
            borderRadius: 10,
            margin: 10,
            paddingBottom: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              // width: "20%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="career-simple-select-label">
                حالة نتيجة اللجنة
              </InputLabel>
              <Select
                labelId="career-simple-select-label"
                id="career-simple-select"
                value={incomeEstimateClass.committeeStatusId}
                label="حالة نتيجة اللجنة"
                onChange={(e) => {
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    committeeStatusId: e.target.value,
                  });
                }}
              >
                {committeeStatusesList?.map((committeeStatus) => {
                  return (
                    <MenuItem
                      value={committeeStatus.id}
                      key={committeeStatus.id + "_type"}
                    >
                      {committeeStatus.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>
          {
             incomeEstimateClass.committeeStatusId==5?
             <div
            style={{
              display: "flex",
              // width: "33%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingTop: 10,
              paddingLeft: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <TextField
                label="القيمة المحددة من قبل اللجنة"
                variant="outlined"
                value={incomeEstimateClass.committeeResult}
                onChange={(e) => {
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    committeeResult: e.target.value,
                  });
                }}
              />
            </FormControl>
            <Typography className="fontForError"></Typography>
          </div>:null
          }
          
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexFlow: "row wrap",
            width: "100%",
            minWidth: 200,
            // border: "1px solid",
            borderColor: "#5f7b8a",
            borderRadius: 10,
            margin: 10,
            paddingBottom: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              // width: "20%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="career-simple-select-label">
                اختر صنف النشاط
              </InputLabel>
              <Select
                labelId="career-simple-select-label"
                id="career-simple-select"
                value={incomeEstimateClass.varietiesWithCarrier}
                label="اختر صنف النشاط"
                onChange={(e) => {
                  setClassAmount(e?.target?.value?.amount);
                  console.log(activitiesByIncomeTaxReportId);
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    varietiesWithCarrierId: e?.target?.value?.id,
                    varietiesWithCarrier: e?.target?.value,
                  });
                }}
              >
                {Array.isArray(activitiesByIncomeTaxReportId) &&
                  activitiesByIncomeTaxReportId?.map((activity) => {
                    return (
                      <MenuItem value={activity} key={activity?.id + "_type"}>
                        {activity?.varieties_carrier?.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>
          <div
            style={{
              display: "flex",
              // width: "33%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingTop: 10,
              paddingLeft: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <TextField
                label="القيمة المحددة للصنف المختار"
                variant="outlined"
                value={classAmount}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(e) => {}}
              />
            </FormControl>
            <Typography className="fontForError"></Typography>
          </div>
        </div>
        <div
            style={{
              display: "flex",
              // width: "20%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              {/* <InputLabel id="career-simple-select-label2">
               ملاحظات
              </InputLabel> */}
              <TextField
                labelId="career-simple-select-label2"
                id="career-simple-select"
                value={incomeEstimateClass.notes}
                multiline
                minRows={4}
                label="ملاحظات"
                onChange={(e) => {
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    notes: e.target.value,
                  });
                }}
              />
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>

      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={() => {
          setsnackBar({ ...snackBar, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar.vertical,
          horizontal: snackBar.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar({ ...snackBar, open: false });
          }}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>

      {/* snack alert box here ... */}
      <Snackbar
        sx={{ height: "100%" }}
        open={snackBar2.open}
        // autoHideDuration={6000}
        onClose={() => {
          setsnackBar2({ ...snackBar2, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar2.vertical,
          horizontal: snackBar2.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar2({ ...snackBar2, open: false });
          }}
          severity={snackBar2.severity}
          sx={{ width: "100%" }}
        >
          {snackBar2.message?.length > 0
            ? snackBar2.message.map((mes) => <p>{mes}</p>)
            : ""}
        </Alert>
      </Snackbar>

      {/* ###==> submit button here...  */}
      <div
        style={{
          display: "flex",
          marginTop: 10,
          backgroundColor: "#fefefe",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 30,

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: "#5f7b8a",
            width: "40%",
            fontSize: "20px",
          }}
          onClick={() => {
            submit();
          }}
        >
          {!loading ? (
            "أضافة"
          ) : (
            <div class="spinner-border " role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          )}
        </Button>
      </div>
    </>
  );
}

export default IncomeEstimateClassForm;
